import { twJoin } from 'tailwind-merge';

import type { DateInputProps } from './date-input';
import { DateInput } from './date-input';

import { FormControl, FormItem, FormMessage } from '../form';

type Props = DateInputProps & {
  formItemClassName?: string;
};

export function FormDateInput({ formItemClassName, ...rest }: Props) {
  return (
    <FormItem className={twJoin(formItemClassName, '[&>.react-datepicker-wrapper]:block')}>
      <FormControl>
        <DateInput {...rest} />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
}
